import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/components/Layout/Layout';

Vue.use(Router);

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
      },
      {
        path: '/about',
        name: 'about',
        component: () => import/* webpackChunkName: "page" */ ('./views/About.vue'),
      },
      {
        path: '/process',
        name: 'process',
        component: () => import/* webpackChunkName: "page" */ ('./views/Process.vue'),
      },
      {
        path: '/post-office',
        name: 'post-office',
        component: () => import/* webpackChunkName: "page" */ ('./views/PostOffice.vue'),
      },
      {
        path: '/price',
        name: 'price',
        // component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
        component: () => import/* webpackChunkName: "page" */ ('./views/Price.vue'),
      },
      {
        path: '/faq',
        name: 'faq',
        component: () => import/* webpackChunkName: "faq" */ ('./views/Faq.vue'),
      },
      {
        path: '/terms',
        name: 'terms',
        component: () => import/* webpackChunkName: "terms" */ ('./views/Terms.vue'),
      },
      {
        path: '/privacy',
        name: 'privacy',
        component: () => import/* webpackChunkName: "terms" */ ('./views/Privacy.vue'),
      },
      {
        path: '/tracking',
        name: 'tracking',
        component: () => import/* webpackChunkName: "tracking" */ ('./views/Tracking.vue'),
      },
      {
        path: '/shop',
        name: 'shop',
        component: () => import/* webpackChunkName: "shop" */ ('./views/Shop.vue'),
      },
      {
        path: '/join-us',
        name: 'join-us',
        component: () => import/* webpackChunkName: "join-us" */ ('./views/JoinUs.vue'),
      },
    ],
  },
];

export default new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  base: process.env.BASE_URL,
  routes,
});
